import { requestFactory, requestBase } from "@/plugins/axios";
// export function userDel(id) {
//    return requestFactory({
//         url: `Worker/delete/${id}`,
//         method: 'DELETE'
//       })
// }
export function userDel(data) {
  return requestBase({
    url: "v1/factory/worker/delete",
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}
// {page,size}
export function changePage(params) {
  return requestBase({
    url: "v1/factory/worker/page",
    method: "GET",
    params,
  });
}
// user: {username: '',phone: '',password: '',cardNumber: '',role: 0}
export function addUser(data) {
  return requestBase({
    url: "v1/factory/worker/add",
    method: "POST",
    data,
  });
}
export function getMsgList(params) {
  return requestBase({
    url: "v1/factory/worker/notice/record",
    method: "GET",
    params,
  });
}
// {"workerId"","name","phone","password","cardNumber","role"}
export function editUser(data) {
  return requestBase({
    url: "v1/factory/worker/update",
    method: "POST",
    data,
  });
}

export function roleList(params) {
  return requestBase({
    url: "/v1/role/list",
    method: "GET",
    params,
  });
}

export function roleAdd(data) {
  return requestBase({
    url: "/v1/role/create",
    method: "POST",
    data,
  });
}

export function delRole(data) {
  return requestBase({
    url: "/v1/role/delete",
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

export function roleDetail(params) {
  return requestBase({
    url: "/v1/role/detail",
    method: "GET",
    params,
  });
}

export function getEdit(data) {
  return requestBase({
    url: "/v1/role/update",
    method: "POST",
    data,
  });
}

export function getRoleList(params) {
  return requestBase({
    url: "/v1/role/privileges",
    method: "GET",
    params,
  });
}

export function updatePrivilege(data) {
  return requestBase({
    url: "/v1/role/updatePrivilege",
    method: "POST",
    data,
  });
}

export function getRole(params) {
  return requestBase({
    url: "/v1/role/dict",
    method: "GET",
    params,
  });
}
